const AddressComponentTypes = [
    "street_number",
    "street_name",
    "unit",
    "neighborhood",
    "city",
    "county",
    "state",
    "country",
    "postal_code",
];
const fieldMap = {
    street_number: "street_number",
    street_name: "route",
    unit: "subpremise",
    neighborhood: "neighborhood",
    city: "locality",
    county: "administrative_area_level_2",
    state: "administrative_area_level_1",
    country: "country",
    postal_code: "postal_code",
};
export const getAddressComponent = (place, types) => {
    const requestData = (types || []).reduce((acc, type) => {
        const component = place?.address_components?.find(({ types }) => types.includes(fieldMap[type]));
        if (component)
            acc[type] = component;
        return acc;
    }, {});
    return requestData;
};
//# sourceMappingURL=utils.js.map